import Nav from "../components/general/NavBar.jsx";
import Footer from "../components/general/footer";
import TypebotFrame from "../components/general/TypebotFrame.jsx";

const SatisfactionFinanceurs = () => {
  return (
    <section>
      <Nav />
      <div style={{ width: "100%", minHeight: "600px" }}>
        <TypebotFrame slug="u-p-4-mind-satisfaction-financeurs-1e2orh8"/>
      </div>
      <Footer border="contact" />
    </section>
  );
};

export default SatisfactionFinanceurs;